import Accounting from './Accounting';
import AppStore from './AppStore';
import BuySell from './BuySell';
import Capital from './Capital';
import Customers from './Customers';
import MyDomains from './MyDomains';
import PayLinks from './PayLinks';
import PaymentTools from './PaymentTools';
import Payouts from './Payouts';
import PointOfSale from './PointOfSale';
import Products from './Products';
import QrCode2 from './QrCode2';
import Reports from './Reports';
import SalesChannels from './SalesChannels';
import Settlements from './Settlements';
import Transactions from './Transactions';
import VirtualTerminal from './VirtualTerminal';

// svg's have been optimized with svgo

// hyphens used to match naming of uxcore2 icons
export default {
  'accounting': Accounting,
  'app-store': AppStore,
  'buy-sell': BuySell,
  'capital': Capital,
  'customers': Customers,
  'my-domains': MyDomains,
  'pay-links': PayLinks,
  'payment-tools': PaymentTools,
  'payouts': Payouts,
  'point-of-sale': PointOfSale,
  'products': Products,
  'qrcode2': QrCode2,
  'reports': Reports,
  'sales-channels': SalesChannels,
  'settlements': Settlements,
  'transactions': Transactions,
  'virtual-terminal': VirtualTerminal
};
